import {
  fetchWithErrorHandling,
  parseJSONWithBetterErrors,
  throwErrorsIfBadResponse,
} from '@github-ui/pull-request-page-data-tooling/fetch-error-handling'
import {PageData} from '@github-ui/pull-request-page-data-tooling/page-data'
import {useMutation} from '@github-ui/react-query'
import type {ReactionViewerGroup} from '@github-ui/reaction-viewer/ReactionGroupsUtils'
import {useReviewSummariesActions, usePullRequestBasePath} from '../stores/selectors'

export function useReactToReviewSummaryMutation() {
  const basePath = usePullRequestBasePath()
  const {updateReviewSummary} = useReviewSummariesActions()

  const onSuccessCallback = (
    data: {reactionGroups: ReactionViewerGroup[]},
    args: {commentId: string; reaction: string; viewerHasReacted: boolean},
  ) => {
    updateReviewSummary({
      match: storedSummary => storedSummary.id === args.commentId,
      transform: oldSummary => {
        if (oldSummary) {
          return {...oldSummary, reactionGroups: data.reactionGroups}
        }
      },
    })
  }

  return useReactToReviewSummaryMutationWithCallback(basePath, onSuccessCallback)
}

export function useReactToReviewSummaryMutationWithCallback(
  basePath: string,
  onSuccessCallback?: (
    data: {reactionGroups: ReactionViewerGroup[]},
    args: {commentId: string; reaction: string; viewerHasReacted: boolean},
  ) => void,
) {
  return useMutation({
    mutationFn: async ({
      commentId,
      reaction,
      viewerHasReacted,
    }: {
      commentId: string
      reaction: string
      viewerHasReacted: boolean
    }) => {
      const apiUrl = `${basePath}/page_data/${
        viewerHasReacted ? PageData.removeCommentReaction : PageData.addCommentReaction
      }`

      const response = await fetchWithErrorHandling(apiUrl, {
        method: 'POST',
        body: {
          reaction,
          reviewSummaryCommentId: commentId,
        },
      })

      const json = await parseJSONWithBetterErrors(response)
      throwErrorsIfBadResponse(response, json)
      return json
    },
    onSuccess: onSuccessCallback,
  })
}
